import React from 'react';
import { Link } from "react-router-dom";

const Quiz = ({ quiz }) => {
    const { id, name, logo, total } = quiz;
    return (

        <div className="flex flex-col transition duration-300 bg-white rounded shadow-sm hover:shadow">
            <div className="relative w-full h-48">
                <img
                    src={logo}
                    className="object-cover w-full h-full rounded-t bg-gray-400"
                    alt="Plan"
                />
            </div>
            <div className="flex flex-col justify-between flex-grow p-8 border border-t-0 rounded-b">
                <div>
                    <div className=" text-3xl font-semibold">{name}</div>
                    <p>Total Quiz: {total} </p>
                    <Link to={`/home/${id}`} className="bg-blue-500 hover:bg-blue-700 block my-2 text-white font-bold py-2 px-4 rounded">
                        Start Quiz
                    </Link>

                </div>

            </div>
        </div>


    );
};

export default Quiz;